export default "__VITE_ASSET__DDGpndAd__"